import React, { useState } from "react";
import GetSignUpOffer from "../getSignUpOffer/getSignUpOffer";
import { Box, Grid, Typography, IconButton, Drawer } from "@mui/material";
import ProductSearchPanel from "../productSearchPanel/productSearchPanel";
import CustomLocationSelectField from "../uiElements/form/customLocationSelectField";
import { Link as RouterLink } from "react-router-dom";
import Navbar from "../navbar/navbar";
import ScrollableTabs from "../uiElements/scrollableTabList/scrollableTabList";
import {
  AccountBalance,
  Celebration,
  Description,
  Folder,
  Person,
  Work,
  Link,
  Menu as MenuIcon,
} from "@mui/icons-material";
import ScrollableWrestlerTabs from "../uiElements/scrollableWrestlerTabList/scrollableWrestlerTabList";
import CustomCategoryButton from "../uiElements/buttons/customCategoryButton";
import ResponsiveDialog from "../uiElements/dialog/responsiveDialog";
import SignInScreen from "src/screens/outerScreens/signin/signInScreen";
import SignInResponsiveDialog from "../uiElements/dialog/signInResponsiveDialog";
import CustomerProfileMenu from "../customer_profile_menu/customerProfileMenu";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "src/store/store";
import { fetchCart } from "src/redux/cart/cartSlice";
import { useEffect } from "react";
import UseHeader from "./useHeader";

const Header = () => {
  const { superStarList, promotionalPartnerList } = UseHeader();

  const isLoggedIn = !!sessionStorage.getItem("Token");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const navigate = useNavigate();
  const cartProductCount = useSelector(
    (state: RootState) => state.cart.lineCount ?? state.cart.items.length,
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchCart());
    } else {
      // If not logged in, clear cart
      // But since persist, maybe not, but for now, assume logout clears
    }
  }, [isLoggedIn, dispatch]);
  const handleDeleteDialogOpen = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const tabAvatarStyle: React.CSSProperties = {
    width: 36,
    height: 36,
    borderRadius: "100%",
    objectFit: "cover",
  };

  const tabBrandLogoStyle: React.CSSProperties = {
    height: 28,
    objectFit: "cover",
  };

  return (
    <>
      <Box sx={{ backgroundColor: "#000000" }}>
        <GetSignUpOffer />
        <Box sx={{ px: 3, py: 1 }}>
          <Grid container alignItems="center" spacing={2}>
            {/* 1️⃣ Logo & Hamburger */}
            <Grid item xs={6} sm={4} md={2} order={{ xs: 1, sm: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
                <IconButton
                  onClick={() => setIsDrawerOpen(true)}
                  sx={{
                    display: { xs: "flex", sm: "flex", md: "flex", lg: "none" },
                    color: "#fff",
                    p: 0.5,
                  }}
                >
                  <MenuIcon />
                </IconButton>
                <Box
                  component={RouterLink}
                  to="/"
                  sx={{ display: "inline-block" }}
                >
                  <Box
                    component="img"
                    src="/logo.png"
                    alt="logo"
                    sx={{
                      height: { xs: 40, sm: 50, md: 50 },
                      width: "auto",
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* 2️⃣ Location */}
            <Grid
              item
              xs={6}
              sm={4}
              md={2}
              order={{ xs: 3, sm: 3 }}
              sx={{
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
            >
              <CustomLocationSelectField />
            </Grid>

            {/* 3️⃣ Search */}
            <Grid item xs={12} sm={12} md={6} order={{ xs: 4, sm: 4 }}>
              <ProductSearchPanel
                onSearch={(term) => console.log("Searching for:", term)}
              />
            </Grid>

            {/* 4️⃣ Icons */}
            <Grid
              item
              xs={6}
              sm={4}
              md={2}
              order={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "flex-end",
                  md: "flex-end",
                },
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: 2, sm: 2, md: 2, lg: 4 },
                  alignItems: "center",
                }}
              >
                <Box>
                  <Box
                    onClick={(e) => {
                      e.preventDefault();

                      if (isLoggedIn) {
                        navigate("/Wishlist"); // go to page
                      } else {
                        handleDeleteDialogOpen(); // open login dialog
                      }
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      textDecoration: "none",
                      color: "#fff",
                      cursor: "pointer",
                      transition: "0.3s",
                      "&:hover": {
                        opacity: 0.7,
                      },
                    }}
                  >
                    <img
                      src="../Wishlist_icon.svg"
                      alt="Wishlist"
                      style={{ height: "20px" }}
                    />
                  </Box>
                </Box>
                <Box sx={{ position: "relative" }}>
                  <Box
                    component={RouterLink}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        cartProductCount > 0 ? "/shoppingCart" : "/emptyCart",
                      );
                    }}
                    to="/emptyCart"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      textDecoration: "none",
                      position: "relative",
                      color: "#fff",
                      transition: "0.3s",
                      "&:hover": {
                        opacity: 0.7,
                      },
                    }}
                  >
                    <img
                      src="../shopping_bag.svg"
                      alt="Shopping Bag"
                      style={{ width: "20px", cursor: "pointer" }}
                    />
                    <Box
                      sx={{
                        background: "#6A0DAD",
                        color: "#fff",
                        borderRadius: "100px",
                        padding: "5px",
                        position: "absolute",
                        bottom: "-5px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "18px",
                        height: "18px",
                      }}
                    >
                      <Typography sx={{ lineHeight: 1, fontSize: "10px" }}>
                        {cartProductCount}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    textDecoration: "none",
                  }}
                >
                  {!isLoggedIn ? (
                    <Box
                      onClick={(e) => {
                        e.preventDefault();
                        handleDeleteDialogOpen();
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        textDecoration: "none",
                        color: "#fff",
                        transition: "0.3s",
                        "&:hover": {
                          opacity: 0.7,
                        },
                      }}
                    >
                      <img
                        src="../profile_icon.svg"
                        alt="Profile"
                        style={{ width: "20px", cursor: "pointer" }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        transition: "0.3s",
                      }}
                    >
                      <CustomerProfileMenu />
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ margin: "8px 0 0 25px" }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={2}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <CustomCategoryButton />
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <Navbar
                mobileDrawerOpen={isDrawerOpen}
                onMobileDrawerClose={() => setIsDrawerOpen(false)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <ScrollableTabs
                onTabChange={(value) => {
                  navigate("/PromotionalPartner", {
                    state: { promotionalPartnerID: value },
                  });
                }}
                tabs={promotionalPartnerList.map((item: any) => ({
                  value: item.PromotionalPartnerMasterID.toString(),
                  icon: (
                    <img
                      src={item.ImagePath}
                      alt={item.PromotionalPartner}
                      style={tabBrandLogoStyle}
                    />
                  ),
                  content: <></>,
                }))}
              />
              {/* <ScrollableTabs
                tabs={[
                  {
                    value: "2",
                    icon: (
                      <img
                        src="../disney.png"
                        alt="John Cena"
                        style={tabBrandLogoStyle}
                      />
                    ),
                    content: <></>,
                  },
                ]}
              /> */}
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            marginTop: {
              xs: "10px",
              sm: "10px",
              md: "10px",
              lg: "0px",
              xl: "0px",
            },
          }}
        >
          <ScrollableWrestlerTabs
          onTabChange={(value) => {
                  navigate("/shop", {
                    state: { SuperStarMasterID: value },
                  });
                }}
            tabs={superStarList.map((item: any) => ({
              label: item.SuperStarName,
              value: item.SuperStarMasterID.toString(),
              icon: (
                <img
                  src={item.ImagePath}
                  alt={item.SuperStarName}
                  style={tabAvatarStyle}
                />
              ),
              content: <></>,
            }))}
          />

          {/* <ScrollableWrestlerTabs
            tabs={[
              {
                label: "John Cena1",
                value: "2",
                icon: (
                  <img
                    src="../johncena.png"
                    alt="John Cena"
                    style={tabAvatarStyle}
                  />
                ),
                content: <></>,
              },
            ]}
          /> */}
        </Box>
      </Box>

      {/* Mobile drawer uses Navbar's own mobile drawer behaviour now */}

      <SignInResponsiveDialog
        open={isDeleteDialogOpen}
        handleClose={handleDeleteDialogClose}
      >
        <>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              order={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
            >
              <img
                src="/login_img.jpg"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              order={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }}
            >
              <SignInScreen />
            </Grid>
          </Grid>
        </>
      </SignInResponsiveDialog>
    </>
  );
};

export default Header;
